import http from "../http-common";

class MaterialBrandDataService {
  getAll() {
    return http.get("/materialbrands");
  }

  getMaterialBrandByDescr(condition, sortfield,sorttype) {
    return http.get(`/materialbrands/search/?materialbrandname=${condition}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  get(id) {
    return http.get(`/materialbrands/${id}`);
  }

  create(data) {
    return http.post("/materialbrands/newmaterialbrand", data);
  }

  update(id, data) {
    return http.put(`/materialbrands/${id}`, data);
  }

  delete(id) {
    return http.delete(`/materialbrands/${id}`);
  }

  deleteAll() {
    return http.delete(`/materialbrands`);
  }

  findById(id) {
    return http.get(`/materialbrands?id=${id}`);
  }
}

export default new MaterialBrandDataService();